import { HistoricalResponse } from "./historical-response";

export interface IHistoricalInspections {
  id?: number;
  equipmentId?: number;
  startDate?: string
  executor?: number;
  versionInspection?: string;
  inspectionCode?: string;
  dateInspectionFormat?: Date | string;
  equipmentBrand?: string;
  equipmentName?: string;
  userName?: string;
  code?: string;
  currentOdometer?: number;
  questions?: HistoricalResponse[];
  formId?: number;
  formName?: string;
  finalDate?: string;
  periodicityType?: string;
  periodicityValue?: number;
  formattedDateInspectionFormat ?: string;

}

export class HistoricalInspections implements IHistoricalInspections {
  id?: number;
  equipmentId?: number;
  startDate?: string
  executor?: number;
  versionInspection?: string;
  inspectionCode?: string;
  dateInspectionFormat?: Date | string;
  equipmentBrand?: string;
  equipmentName?: string;
  userName?: string;
  code?: string;
  currentOdometer?: number;
  questions?: HistoricalResponse[];
  formId?: number;
  formName?: string;
  finalDate?: string;
  periodicityType?: string;
  periodicityValue?: number;
  formattedDateInspectionFormat ?: string;
}